/**
 * What the till calls the shop it belongs to.
 *
 * The header and the receipt both used a hardcoded product name — every till in
 * every shop said "لوما استور", and every slip said "فروشگاه لوما". That is the
 * name of the software. The person at the counter already knows what software
 * they are using; what they cannot see is whose counter this is, which matters
 * the moment somebody runs two branches on two screens. On a receipt it matters
 * more: the slip is the record of who took the money, and naming the vendor on
 * it is simply wrong.
 *
 * A device learns its shop's name by replication, so there is a window where it
 * has none — a till must open and sell before it has been told who it belongs
 * to. Empty is UNKNOWN, and unknown falls back rather than rendering a heading
 * with nothing in it.
 */
export function shopLabel(tenantName: string | null | undefined, fallback: string): string {
  const name = (tenantName ?? '').trim();
  return name === '' ? fallback : name;
}
